import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useCart } from "../context/CartContext";
import axios from "axios";
import "../assets/services.css";

const SubProducts: React.FC = () => {
  const [subProducts, setSubProducts] = useState([]);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const subCategoryId = params.get("id");
  const subcategoryName = params.get("name");
  const { addToCart } = useCart();

  useEffect(() => {
    const fetchSubProduct = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_LYRAZONE_BASE_URL}/subproducts/${subCategoryId}`,
        );
        setSubProducts(response.data.subProduct);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSubProduct();
  }, []);

  const productData = (productId: any) => {
    window.location.href = `/singleproduct?id=${productId}`;
  };

  return (
    <>
      <div id="home-p" className="home-p pages-head11 text-center">
        {/* <div className="container">
          <h1 className="wow fadeInUp" data-wow-delay="0.1s">
            POINT OF SALE
          </h1>
          <p>HARDWARE SOLUTIONS</p>
        </div> */}
      </div>
      {/* <!--/end container--> */}

      <section id="business-growth-p1" className="business-growth-p1 bg-gray">
        <div className="container">
          <div className="row title-bar">
            <div className="col-md-12">
              <h1 className="wow fadeInUp">{subcategoryName}</h1>
              <div className="heading-border"></div>
              <p className="wow fadeInUp" data-wow-delay="0.4s">
                We have been covering full range of Computer Hardware with
                collection of reputed brands like Dell, HP, Lenovo, Acer, Asus,
                MSI, Apple, Microsoft Surface, Gigabyte, Samsung, Toshiba,
                Fujitsu, Jadever, Optimuz, Aclas, Digi, Bizerba and so on.
                Quality is our top most priority that's why we say
                <br />
                SUPER QUALITY HARDWARE{" "}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="comp-offer">
        <div className="container-fluid">
          <div className="row">
            <div className="heading-border-light"></div>

            {subProducts.length > 0 ? (
              subProducts.map((subproduct: any, index: any) => (
                <div
                  key={index}
                  className="col-md-3 col-sm-6 desc-comp-offer wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <div className="desc-comp-offer-cont">
                    <div className="thumbnail-blogs">
                      <a onClick={() => productData(subproduct.id)}>
                        <img
                          src={`${import.meta.env.VITE_LYRAZONE_IMAGE_URL}/uploads/products/${subproduct.id}/${subproduct.image_path}`}
                          className="img-fluid"
                          alt={subproduct.productName}
                        />
                      </a>
                    </div>

                    <h3>{subproduct.productName}</h3>

                    {/* <p className="desc">
                      Originated insect-proof loop design (patented) in the
                      world.
                    </p> */}
                    <p className="desc">{subproduct.shortDescription}</p>

                    <a>
                      <button
                        className="btn btn-general btn-silver"
                        role="button"
                        onClick={() =>
                          addToCart({
                            id: subproduct.id,
                            barCode: subproduct.barCode,
                            vendor_id: subproduct.vendor_id,
                            productName: subproduct.productName,
                            active_price: subproduct.active_price,
                            image_path: subproduct.image_path,
                            variant: subproduct.color_name || "Default",
                          })
                        }
                      >
                        Add To Cart
                      </button>
                    </a>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <p>NO PRODUCT FOUND</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default SubProducts;
